import React from "react";
import SlideyMenu from "../../shared/containers/SlideyMenu";
import { connect } from "react-redux";
import Navbar from "./Navbar";

export const LargeScreenMenu = ({ selectedMenu, highlightedMenu }) => {
  return (
    <SlideyMenu selectedMenu={selectedMenu} highlightedMenu={highlightedMenu}>
      <Navbar />
    </SlideyMenu>
  );
};

export const mapStateToLargeScreenMenu = ({ navigationMenuReducer }) => ({
  highlightedMenu: navigationMenuReducer.highlightedMenu,
  selectedMenu: navigationMenuReducer.selectedMenu
});

export default connect(mapStateToLargeScreenMenu)(LargeScreenMenu);
